<template>
  <div class="input">
    <!--  -->
    <input
      v-if="!noPast"
      :class="editDisable ? 'bgchui' : ''"
      :disabled="editDisable"
      v-bind="$attrs"
      :value="value"
      @input="onInput"
      @blur="getTel"
      @keyup.enter="setKey"
    >
    <input
      v-else
      :class="editDisable ? 'bgchui' : ''"
      :disabled="editDisable"
      v-bind="$attrs"
      :value="value"
      @input="onInput"
      @blur="getTel"
      @keyup.enter="setKey"
      @paste="paste"
    >
    <svg
      v-if="delBtn && !editDisable"
      class="icon del"
      aria-hidden="true"
      @click="del"
    >
      <use xlink:href="#icon-shanchux" />
    </svg>
  </div>
</template>

<script>
export default {
  props: ['value', 'delBtn','editDisable', 'noPast'],
  methods: {
    paste (e) {
      e.preventDefault()
      return ""
    },
    onInput(e) {
      this.$emit('input', e.target.value);
    },
    del() {
      this.$emit('del');
    },
    getTel(e) {
      this.$emit('blur');
    },
    setKey() {
      this.$emit('keyupEnter');
    }
  }
};
</script>
<style lang="scss">
.input {
  flex: 1;
  display: flex;
  align-items: center;
  input {
    background-color: inherit;
    width: 100%;
    border: none;
    padding: 15px 0px;
    font-size: 17px;
  }
  .bgchui{
    color: #999;;
  }
  // 兼容ios颜色浅的问题
  input:disabled, input[disabled]{
  color: #999;
  -webkit-text-fill-color:#999;
  -webkit-opacity:1;
  opacity: 1;
  }
  input::-webkit-input-placeholder {
    /* WebKit browsers */
    line-height: 1.8rem;
    color: #999;
  }
  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #999;
  }
  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #999;
  }
  input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #999;
  }
  .del {
    font-size: 28px;
  }
}
</style>
